import React from "react";
import { useQuery } from "@tanstack/react-query";
import { adminAxios } from "../../axiosInstance";

const fetchFundingReadiness = async () => {
  const response = await adminAxios.get("analytics/funding/readiness");
  return response?.data?.data;
};

const SEGMENT_COUNT = 4;

// Battery colours by number of lit segments (1-4)
const LEVEL_COLORS = ["#9ca3af", "#ef4444", "#f59e0b", "#facc15", "#22c55e"];

function FundingReadinessCard() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["funding-readiness"],
    queryFn: fetchFundingReadiness,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const rawScore = Number(data?.FundingReadiness);
  const hasScore = Number.isFinite(rawScore);
  const score = hasScore ? Math.min(100, Math.max(0, Math.round(rawScore))) : 0;
  const litSegments = Math.ceil((score / 100) * SEGMENT_COUNT);
  const color = LEVEL_COLORS[litSegments];

  return (
    <div className="flex flex-col items-center bg-white rounded-3xl shadow-md gap-6 px-6 py-8 font-inter w-full max-w-md mx-auto">
      <h3 className="text-xl font-semibold text-gray-500 text-center">Funding Readiness Score</h3>

      {isLoading ? (
        <div className="flex justify-center items-center h-60">
          <p>Loading...</p>
        </div>
      ) : isError || !hasScore ? (
        <div className="flex justify-center items-center h-60">
          <p className="text-red-500">Unable to load funding readiness.</p>
        </div>
      ) : (
        <>
          {/* Battery gauge: 4 segments, lit from the bottom up and coloured by level */}
          <div
            className="flex flex-col items-center"
            role="progressbar"
            aria-valuenow={score}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label="Funding readiness"
          >
            <div className="w-10 h-3 rounded-t-lg" style={{ backgroundColor: color }} />
            <div
              className="flex flex-col-reverse gap-2 w-32 h-56 rounded-3xl border-[6px] p-2.5"
              style={{ borderColor: color }}
            >
              {Array.from({ length: SEGMENT_COUNT }, (_, i) => (
                <div
                  key={i}
                  className="flex-1 rounded-lg transition-colors duration-500"
                  style={{ backgroundColor: i < litSegments ? color : "#f3f4f6" }}
                />
              ))}
            </div>
          </div>

          <div className="flex flex-col items-center gap-1">
            <span className="text-5xl font-black leading-none" style={{ color }}>
              {score}%
            </span>
            <p className="text-sm text-gray-500 text-center">Based on your business performance</p>
          </div>
        </>
      )}
    </div>
  );
}

export default FundingReadinessCard;
